<template>
  <div class="password-strength">
    <div class="strength">
      <div class="strength-row" :class="{ low, medium, safe }"></div>
      <div class="strength-row" :class="{ medium, safe }"></div>
      <div class="strength-row" :class="{ safe }"></div>
    </div>
    <div class="strength-description">{{ $pt('registration.client.info.password.strength', this.strength) }}</div>
  </div>
</template>

<script>
import { passwordStrength } from '@/constants/registration';

export default {
  name: 'PasswordStrength',
  props: {
    strength: {
      type: String,
      validator: value => Object.values(passwordStrength).includes(value),
    },
  },
  computed: {
    low() {
      return this.strength === passwordStrength.low;
    },
    medium() {
      return this.strength === passwordStrength.medium;
    },
    safe() {
      return this.strength === passwordStrength.safe;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/design-system';

.password-strength {
  display: flex;
  justify-content: space-between;
}

.strength {
  display: inline-flex;
}

.strength-row {
  height: $space-1;
  width: 73px;
  margin: 5px;
  border-radius: 2.5px;
  background-color: $gray-400;

  &.low {
    background-color: $auth-error;
  }

  &.medium {
    background-color: $warning-500;
  }

  &.safe {
    background-color: $auth-success;
  }
}

.strength-description {
  color: $auth-text-muted;
  font-size: $font-size-sm;
  letter-spacing: 0;
  line-height: $font-size-lg;
  text-transform: capitalize;
}
</style>
